import React from 'react'
import Box from '@mui/material/Box'
import { backgroundGradient } from 'bizzkit/style/top-bar'
import { SxProps, Theme, useTheme } from '@mui/material/styles'
import { extras as themeExtras } from '../../shared/theme'

type Props = {
    children?: {
        topLeft: React.ReactElement
        topMiddle: React.ReactElement
        topRight: React.ReactElement
        middleLeft: React.ReactElement
        middleRight: React.ReactElement
    }
}

const topBarStyles = (theme: Theme): SxProps<Theme> => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(2, 6),
    background: backgroundGradient,
    color: themeExtras.primaryLight,
})

const Header: React.FC<Props> = (props) => {
    const theme = useTheme()

    return (
        <header
            css={{
                borderBottom: `1px solid ${themeExtras.primaryLight}`,
            }}
        >
            <Box sx={topBarStyles(theme)} color='primary.contrastText'>
                <Box display='flex'>
                    {props.children && props.children.topLeft}
                </Box>
                <Box display='flex'>
                    {props.children && props.children.topMiddle}
                </Box>
                <Box display='flex' justifyContent='flex-end'>
                    {props.children && props.children.topRight}
                </Box>
            </Box>

            <Box
                sx={{
                    background: 'white',
                    color: (theme) => theme.palette.primary.main,
                    paddingLeft: (theme) => theme.spacing(6),
                    paddingRight: (theme) => theme.spacing(6),
                    [theme.breakpoints.up('lg')]: {
                        paddingLeft: (theme) => theme.spacing(22),
                        paddingRight: (theme) => theme.spacing(22),
                    },
                    paddingTop: '3px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                }}
            >
                <Box display='flex' flex='1'>
                    {props.children && props.children.middleLeft}
                </Box>
                <Box display='flex' flex='1' justifyContent='flex-end'>
                    {props.children && props.children.middleRight}
                </Box>
            </Box>
        </header>
    )
}

export default Header
